module.exports = __webpack_public_path__ + "static/media/teacher2.a7e6a2e0.svg";